import { FC, ReactNode } from 'react';

import classNames from 'classnames';

import styles from './panel-title.module.scss';

import { useWidth } from 'hooks';
import { HeaderControls, IHeaderControls } from 'views/components/HeaderControls';
import { Headline4 } from 'views/components/UI/Headline';

interface IPanelTitleProps {
  children: ReactNode;
  action?: ReactNode;
  controls?: IHeaderControls;
  secondary?: ReactNode;
  className?: string;
}

const PanelTitle: FC<IPanelTitleProps> = ({
  children,
  action,
  controls,
  secondary,
  className,
}) => {
  const { isShow: isSearchOpen, setIsShow: setIsSearchOpen } = useWidth(true);
  const shouldHideTitleForSearch =
    Boolean(controls?.search) && controls?.search?.collapsible !== false && isSearchOpen;

  return (
    <div className={classNames(styles.header, className)}>
      <div className={styles.wrapper}>
        <Headline4
          color="var(--sk-text-subtle)"
          className={classNames(styles.title, {
            [styles.titleSearchOpen]: shouldHideTitleForSearch,
          })}
        >
          {children}
        </Headline4>
        {(action || controls) && (
          <div className={styles.actions}>
            {action ??
              (controls && (
                <HeaderControls
                  controls={controls}
                  isSearchOpen={isSearchOpen}
                  setIsSearchOpen={setIsSearchOpen}
                />
              ))}
          </div>
        )}
      </div>
      {secondary && <div className={styles.secondary}>{secondary}</div>}
    </div>
  );
};

export { PanelTitle };
